import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export function scrollToTarget(target) {
    if (lenisInstance) {
        lenisInstance.scrollTo(target, { offset: -72, duration: 1.2 });
    } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "auto" });
    }
}

export function useLenis() {
    useEffect(() => {
        if (lenisInstance) return undefined;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        lenisInstance = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisInstance = null;
        };
    }, []);
}
